<template>
  <div>
    <b-form-group v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-checkbox>{{
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: "label",
              value: properties.label,
              defaultValue: false,
              form: this.form
            })
          : properties.label
      }}</b-form-checkbox>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <boolean-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-show="!computedHidden"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <b-form-checkbox v-model="controlValue" style="font-size: 14px">{{
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: "label",
              value: properties.label,
              defaultValue: false,
              form: this.form
            })
          : properties.label
      }}</b-form-checkbox>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
    >
      <div>
        <b-icon-check-square-fill
          class="text-primary"
          v-if="controlValue"
        /><b-icon-square v-else />
        {{
          computedConditions.label
            ? superComputeFormSubmitterValue({
                elementId: this.id,
                property: "label",
                value: properties.label,
                defaultValue: false,
                form: this.form
              })
            : properties.label
        }}
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import BooleanV1Properties from "./BooleanV1Properties.vue";
export default {
  name: "BooleanV1",
  components: { BooleanV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId"],
  data() {
    return {
      computedProperties: ["label", "hidden"],
      computedConditions: {}
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue:
          typeof this.properties.value == "string" &&
          this.properties.value.includes("{{")
            ? this.superComputeFormSubmitterValue({
                elementId: this.id,
                property: "value",
                value: this.properties.value,
                defaultValue: false,
                form: this.form
              })
            : false,
        hardSet: this.properties.resetStoreValues
      });
    }
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
    }
    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", [
      "setFormSubmitterComponentValue",
      "setFormSubmitterComponentMetadata"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";

      return `
      <fieldset aria-describedby="" class="form-group">
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${
            this.controlValue
              ? '<i class="fas fa-check-square text-primary"></i>'
              : '<i class="far fa-square"></i>'
          }
          ${this.getComponentComputedProperties("label")}
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: this.properties.resetStoreValues
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
